/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-11-08 23:13:46
 * @LastEditTime: 2019-11-09 00:07:56
 * @LastEditors: he.jianbo
 */
/**
 * 描述：辅助编辑中的敏感词校验模块
 * 作者：Bai.Zhiming
 * 日期：2017-9-6
 */
"use strict";
angular.module("scSensitiveWordCheckModule", [])
    .directive("scSensitiveWordCheck", ["$timeout", "sensitiveWordCheckService", function($timeout, sensitiveWordCheckService) {
        return {
            restrict: 'E',
            replace: true,
            scope: false,
            templateUrl:'./editingCenter/directive/supportCreation/sensitiveWordCheck/sensitiveWordCheck.html',
            link: function(scope, $elem, $attrs) {
                initStatus();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.data = {};
                    sensitiveWordCheckService.sensitiveWordsForFuncun().then(function(sensitiveWords) {
                        scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                        scope.$parent.$parent.status.isCheckSensitiveWords = Math.random();
                        sensitiveWordCheckService.markFuncunWordCompare(scope); //编辑器敏感词比对方法
                    });
                    scope.$on("$destroy", function() {
                        scope.$parent.$parent.status.isCheckSensitiveWords = false;
                        $(".hasSensitiveWordInputBox").find("span.ng-scope").html("");
                        $(".hasSensitiveWordInputBox").removeClass("hasSensitiveWordInputBox");
                        $(".hasSensitiveWord").removeClass("hasSensitiveWord");
                        sensitiveWordCheckService.leaveCheckoutMode(scope);
                        //取消敏感词校验代码
                    });
                }
            }
        };
    }]);